// removed by extract-text-webpack-plugin
module.exports = {"productWrapper":"CentricUI__BuilderCard__BuilderCardWithPopover__productWrapper","popoverContainer":"CentricUI__BuilderCard__BuilderCardWithPopover__popoverContainer","skeleton":"CentricUI__BuilderCard__BuilderCardWithPopover__skeleton","loading":"CentricUI__BuilderCard__BuilderCardWithPopover__loading","productPopover":"CentricUI__BuilderCard__BuilderCardWithPopover__productPopover"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/product/productCard/components/BuilderCard/BuilderCardWithPopover.css
// module id = 1604
// module chunks = 10